import { innovorderApi } from '../index';
import { ApiResponse } from '../providers/innovorder.types';
import { WeborderingConfiguration, GetWeborderingConfigurationPayload } from './brand.type';

const brandApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getWeborderingConfiguration: build.query<
            WeborderingConfiguration,
            GetWeborderingConfigurationPayload
        >({
            query: ({ brandHash }) => ({
                url: `/brands/webordering-configuration/${brandHash}`,
                method: 'GET',
            }),
            providesTags: [],
            transformResponse: (response: ApiResponse<WeborderingConfiguration>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
    }),
});

export const { useGetWeborderingConfigurationQuery } = brandApi;
